import React from "react";
import { LINKS } from "@/constants/links";
import { MessageCircle, Coffee, ArrowUpRight } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden border-t border-[#C9A87C]/15 bg-[#0A0908]"
    >
      {/* Massive watermark */}
      <div className="pointer-events-none absolute inset-x-0 -bottom-6 flex select-none justify-center">
        <span className="footer-wordmark text-[24vw] leading-none">
          Tapestry
        </span>
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 pb-24 pt-20 md:px-10">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-4">
          <div className="md:col-span-2">
            <p className="eyebrow">Tapestry Games</p>
            <p className="font-serif-display mt-6 max-w-md text-2xl italic leading-tight text-[#F2EFEB]">
              An independent TTRPG publisher weaving worlds worth returning to.
            </p>
          </div>

          <div>
            <p className="text-[10px] uppercase tracking-[0.32em] text-[#6E6A64]">
              Games
            </p>
            <ul className="mt-4 space-y-3 text-sm text-[#A39D95]">
              <li>
                <a
                  href={LINKS.godComplexSite}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-godcomplex-link"
                  className="inline-flex items-center gap-2 hover:text-[#C9A87C]"
                >
                  God Complex <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
              <li>
                <span
                  data-testid="footer-fatewoven-link"
                  className="inline-flex items-center gap-2 text-[#6E6A64]"
                >
                  Fatewoven — site coming soon
                </span>
              </li>
              <li>
                <a
                  href={LINKS.backerkit}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-backerkit-link"
                  className="inline-flex items-center gap-2 hover:text-[#C9A87C]"
                >
                  BackerKit Launch <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-[10px] uppercase tracking-[0.32em] text-[#6E6A64]">
              Community
            </p>
            <ul className="mt-4 space-y-3 text-sm text-[#A39D95]">
              <li>
                <a
                  href={LINKS.discord}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-discord-link"
                  className="inline-flex items-center gap-2 hover:text-[#C9A87C]"
                >
                  <MessageCircle className="h-3.5 w-3.5" /> Discord
                </a>
              </li>
              <li>
                <a
                  href={LINKS.buyMeACoffee}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-buymeacoffee-link"
                  className="inline-flex items-center gap-2 hover:text-[#C9A87C]"
                >
                  <Coffee className="h-3.5 w-3.5" /> Buy Me a Coffee
                </a>
              </li>
              <li>
                <a
                  href="/bingo/"
                  data-testid="footer-bingo-link"
                  className="inline-flex items-center gap-2 hover:text-[#C9A87C]"
                >
                  Bingo Tracker
                </a>
              </li>
              <li>
                <a
                  href="#newsletter"
                  data-testid="footer-newsletter-link"
                  className="inline-flex items-center gap-2 hover:text-[#C9A87C]"
                >
                  The Dispatch
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 divider-thread" />

        <div className="mt-8 flex flex-col items-start justify-between gap-4 text-xs text-[#6E6A64] md:flex-row md:items-center">
          <span data-testid="footer-copy">
            © {year} Tapestry Games. All threads reserved.
          </span>
          <span className="uppercase tracking-[0.28em]">
            Tapestry<span className="text-[#C9A87C]">.</span>Games
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
